/**
 * AutoDrive Theme — Countdown Timer JS
 *
 * Reads [data-countdown] elements with a data-end-date attribute
 * (ISO 8601 string, e.g. "2025-12-31T23:59:59Z") and updates
 * the H / M / S display every second. Hides the parent section
 * when the timer expires.
 */

(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown(el) {
    var endDate    = el.dataset.endDate;
    if (!endDate) return;

    var endTime    = new Date(endDate).getTime();
    var hoursEl    = el.querySelector('[data-countdown-hours]');
    var minutesEl  = el.querySelector('[data-countdown-minutes]');
    var secondsEl  = el.querySelector('[data-countdown-seconds]');
    var section    = el.closest('[data-flash-deals-section]');

    if (!hoursEl || !minutesEl || !secondsEl) return;

    function tick() {
      var now  = Date.now();
      var diff = endTime - now;

      if (diff <= 0) {
        // Timer expired — hide the section or show expired message
        var expiredMsg = el.querySelector('[data-countdown-expired]');
        if (expiredMsg) expiredMsg.style.display = '';
        el.querySelector('[data-countdown-display]') &&
          (el.querySelector('[data-countdown-display]').style.display = 'none');
        return;
      }

      var totalSec = Math.floor(diff / 1000);
      var hours    = Math.floor(totalSec / 3600);
      var minutes  = Math.floor((totalSec % 3600) / 60);
      var seconds  = totalSec % 60;

      hoursEl.textContent   = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);

      // Animate seconds digit on change (add/remove class)
      secondsEl.classList.add('tick');
      setTimeout(function () { secondsEl.classList.remove('tick'); }, 300);

      setTimeout(tick, 1000);
    }

    tick();
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.from(document.querySelectorAll('[data-countdown]')).forEach(initCountdown);
  });

})();
